import { Injectable } from '@angular/core';

import { Decimal } from 'decimal.js';

import { IBetslipState } from '../../../base/store/state';
import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { ICalculatorInput } from '../../bet-generation/models';
import { BetslipGeneratorService } from '../../bet-generation/services/betslip-generator.service';
import UpsellInputBuilder from '../../bet-generation/services/upsell-bet-input-builder';
import { AccaBoostToken } from '../../reward-tokens/reward-tokens.model';
import { isAccaBoostToken } from '../../reward-tokens/services/reward-tokens.utils';
import { TokenValidationInput } from '../../reward-tokens/services/validators/criteria-validator-base.service';
import { getSingleBetValidationInput } from '../../reward-tokens/services/validators/utils/state-extract.helper';
import { UpsellOverridesService } from './upsell-overrides.service';

@Injectable()
export class UpsellSummaryService {
    constructor(
        private upsellInputBuilder: UpsellInputBuilder,
        private betslipGenerator: BetslipGeneratorService,
        private upsellOverridesService: UpsellOverridesService,
    ) {}

    generateSlip(state: IBetslipState, upsellPick: BetslipPick) {
        const upsellInput = this.upsellInputBuilder.getUpsellInput(state, upsellPick);
        const tokenValidationInput = this.getTokensValidationState(state, upsellInput, upsellPick);
        const tokens = this.getTokens(state);
        const overrides = this.upsellOverridesService.getOverrides(tokenValidationInput, tokens);
        const upsellBetslip = this.betslipGenerator.calculate(upsellInput, { overrides });

        return upsellBetslip;
    }

    private getTokens(state: IBetslipState): AccaBoostToken[] {
        return Object.values(state.rewardTokens.tokens)
            .filter((token) => isAccaBoostToken(token))
            .map((token) => token as AccaBoostToken);
    }

    private getTokensValidationState(
        { types, picks: { pickList } }: IBetslipState,
        input: ICalculatorInput,
        upsellPick: BetslipPick,
    ): TokenValidationInput {
        const context = getSingleBetValidationInput(types.singleBet, pickList, upsellPick.id);
        context.selectedType = BetslipType.Combo;
        context.stake = new Decimal(input.betslip[0].stake ?? 0);
        context.hasEachWay = false;
        context.selectedPicks.push(upsellPick);

        return context;
    }
}
